
import http from '@/utils/http-util'
import { MessagePlugin } from "tdesign-vue-next";

export default () => {
    console.log('??/');
    const urlParams = getUrlParams()
    console.log(urlParams, 'urlParams')
    if (!urlParams?.type && urlParams?.type !== 'sso') {
        return false
    }
    console.log('!');
    // 单点登录
    loadLogin({
        source: urlParams.sourceClient,
        ticket: urlParams.ticket
    })
}



async function loadLogin({ source, ticket }) {
    let params = getUrlParams()
    console.log(params, 'params');


    const result = await http({
        url: '/designApi/login',
        method: 'POST',
        data: {
            grant_type: 'xd_sso',
            source,
            ticket,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', }
    })
    
    if (result.data.token) {
        localStorage.setItem('token', result.data.token)
    } else {
        // MessagePlugin.warning('单点登录失败！')
    }
    console.log(result);
}

function getUrlParams() {
    // 获取地址栏参数字符串（不含问号）
    const queryString = window.location.search.slice(1);

    // 将地址栏参数字符串解析为对象
    const params = {};
    queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        if (key && value) {
            params[decodeURIComponent(key)] = decodeURIComponent(value.replace(/\+/g, ' '));
        }
    });

    console.log(`获取地址栏参数：${params}`); // 输出转换后的参数对象
    return params
}